import React, { FunctionComponent } from 'react';

import { useIntl } from 'react-intl';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Theme, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  iconButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  dialogtitle: {
    margin: 0,
    minWidth: '640px',
    padding: theme.spacing(2, 2, 0, 2),
  },
  dialogContent: {
    margin: 0,
    minWidth: '640px',
    padding: theme.spacing(0, 2, 2, 2),
  },
}));

type EmailInputModal = {
  message: string;
  open: boolean;
  onClose: () => void;
};

const EmailInputModal: FunctionComponent<EmailInputModal> = ({
  message,
  open,
  onClose,
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle disableTypography className={classes.dialogtitle}>
        <Typography variant="h6">
          {formatMessage({ id: `contact.modal.title` })}
        </Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.iconButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography>
          {message && formatMessage({ id: `contact.modal.${message}` })}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default EmailInputModal;
